import { InjectionToken } from '@angular/core';
import { BookingServiceBase } from '../client';

export const BOOKING_SERVICE_TOKEN = new InjectionToken<BookingServiceBase>('BookingService');
